
import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import AllocateInventory from "./components/allocateInventory.vue"
import LossReporting from "./components/lossReporting.vue"
import StatusFallback from "./components/statusFallback.vue"
import {
  searchCustomer
} from "@/api/customer";
@Component({
  name: "closingPositionDetail1",
  components: {
    Pagination,
    AllocateInventory,
    LossReporting,
    StatusFallback
  }
})
export default class extends Vue{
  private type = null
  private id = null
  created() {
    this.type = this.$route.query.type
    this.id = this.$route.query.id
    this.init();
  }
  private init() {
    console.log(111)
  }
}
